module.exports = __webpack_public_path__ + "img/registration_at_example_old.f5cee26b.gif";